import Users from './users';
import User from './user';

export default Users;
export { User, Users };
export { createUser, deleteUser, getUser, getUsers, updateUser } from './users';
